<form [formGroup]="requestForm">
  @if (newRequest) {
    <div class="margin-top grid-container">
      <div class="grid-x">
        <div class="cell large-3 bold text-align-center  padding-right">
          <h3>New eDiscovery Request:</h3>
        </div>
        <div class="cell large-9 text-align-right">
          <div class="checkbox">
            <input class="show-for-sr" id="notify" type="checkbox" formControlName="notifyWhenComplete" />
            <label for="notify">
              Notify on completion: <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
            </label>
          </div>
        </div>
        <div class="cell large-3 padding-right">
          <span class="bold">Select Organization:</span> <br />
          @if (organization != null) {
            <span class="bold">Selected Organization: {{organization.name}}</span>
          }
        </div>
        <div class="cell large-9">
          <ag-grid-angular class="data-grid " [gridOptions]="orgGridOptions" [rowData]="availableOrgs$ | async" (selectionChanged)="orgSelectionChanged($event)" aria-label="New Request"></ag-grid-angular>
        </div>
        <div class="cell large-3">&nbsp;</div>
        <div class="cell large-9">
          <div class="checkbox">
            <input class="show-for-sr" id="incOrgNotes" type="checkbox" formControlName="includeOrganizationNotes" />
            <label for="incOrgNotes">
              Include Organization Notes: <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
            </label>
          </div>
        </div>
        <div class="cell large-3 bold  padding-right">
          Select Application Number(s):
        </div>
        <div class="cell large-9">
          <div class="checkbox">
            <input class="show-for-sr" type="checkbox" id="incAppData" formControlName="includeApplData" />
            <label for="incAppData">
              Include Data: <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
            </label>
            <input class="show-for-sr" id="incAppNotes" type="checkbox" formControlName="includeApplNotes" />
            <label for="incAppNotes">
              Include Notes: <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
            </label>
          </div>
        </div>
        <div class="cell large-3">
          &nbsp;
        </div>
        <div class="cell large-9">
          <span style="font-weight: bold; font-style: italic;">Due to the large size of some of the types of applications, a separate request must be made per application.</span>
        </div>
        <div class="cell large-3  padding-right">
          Select one of the applications listed to include application data or notes.
        </div>
        <div class="cell large-9">
          @if (applicationList) {
            @if (applicationList.length === 0) {
              <div class="no-data">
                Selected Organization has no selectable applications.
              </div>
            }
            @if (applicationList.length > 0) {
              <div>
                <ag-grid-angular class="data-grid " [gridOptions]="appGridOptions" [rowData]="applicationList" (selectionChanged)="appSelectionChanged($event)" aria-label="New Request"></ag-grid-angular>
              </div>
            }
          } @else {
            <text-loader [run]="newRequest?.organizationId?.length > 0" [tickType]="'.'" [text]="'Loading Applications'" [interval]="1500"></text-loader>
            @if (!newRequest.organizationId) {
              You must select an Organization before selecting application number(s).
            }
          }
        </div>
        <div class="cell large-3 bold  padding-right">Select Contact(s)' Notes to Include:</div>
        <div class="cell large-9">
          <div class="checkbox">
            <input class="show-for-sr" id="incAllContacts" type="checkbox" formControlName="includeAllContacts" />
            <label for="incAllContacts">
              Include Notes for All Contacts: <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
            </label>
          </div>
        </div>
        <div class="cell large-3 padding-right">
          Select one or more of the contacts listed to include their notes.
        </div>
        <div class="cell large-9">
          @if (contactList) {
            @if (contactList.length === 0) {
              <div class="no-data">
                Selected Organization has no contacts.
              </div>
            }
            @if (contactList.length > 0) {
              <div>
                <ag-grid-angular class="data-grid " [gridOptions]="contactGridOptions" [rowData]="contactList" (selectionChanged)="contactSelectionChanged($event)" aria-label="New Request"></ag-grid-angular>
              </div>
            }
          } @else {
            <text-loader [run]="newRequest?.organizationId?.length > 0" [tickType]="'.'" [text]="'Loading Contacts'" [interval]="1500"></text-loader>
            @if (!newRequest.organizationId) {
              You must select an Organization before selecting contact(s).
            }
          }
        </div>
        <div class="cell large-3 bold  padding-right">Select Ad Hoc Work Order(s) to Include:</div>
        <div class="cell large-9">
          <div class="checkbox">
            <input class="show-for-sr" id="incWorkOrders" type="checkbox" formControlName="includeAllWorkOrders" />
            <label for="incWorkOrders">
              Include All Work Orders: <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
            </label>
          </div>
        </div>
        <div class="cell large-3  padding-right">
          Select one or more of the work orders listed to include their details.
        </div>
        <div class="cell large-9 padding-right">
          @if (workOrderList) {
            @if (workOrderList.length === 0) {
              <div class="no-data">
                Selected Organization has no Ad Hoc Work Orders.
              </div>
            }
            @if (workOrderList.length > 0) {
              <div>
                <ag-grid-angular class="data-grid " [gridOptions]="workOrderGridOptions" [rowData]="workOrderList" (selectionChanged)="workOrderSelectionChanged($event)" aria-label="New Request"></ag-grid-angular>
              </div>
            }
          } @else {
            <text-loader [run]="newRequest?.organizationId?.length > 0" [tickType]="'.'" [text]="'Loading Work Orders'" [interval]="1500"></text-loader>
            @if (!newRequest.organizationId) {
              You must select an Organization before selecting work order(s).
            }
          }
        </div>
      </div>
    </div>
  }
</form>



